export default "__VITE_ASSET__9f1edfbc__"